<script>
    import { _ } from 'svelte-i18n';
    import {onMount} from 'svelte';
    import Chart from 'chart.js';
    import ChartDataLabels from 'chartjs-plugin-datalabels';

    export let bodypart = "";
    export let calculatedValues;
    let chartId = `resultChart-${bodypart}`;

    const groupNames = (type, values) => {
        let groups = []
        for (let value of values) {
            if (value.muscleType == type) {
               
                if (value.name.includes('_1')) {
                    value.name = value.name.replace('_1', '')
                }
                if (value.name.includes('_2')) {
                    value.name = value.name.replace('_2', '')
                }

                if (value.name != "f_plant") {
                    groups.push($_('calculator.muscles.short.' + value.name));
                }
            }
        }

        if (type == "leg") {
            let filteredGroups = [...new Set(groups)]
        
            groups = filteredGroups;
        }

        return groups;
    }

    const chartData = (side, type, values) => {
        // side: 1 for right, 2 for left
        let data = [];
        for (let value of values) {
            if (value.muscleType == type) {
                if (side == 1) {
                    if (isNaN(value.percRight)) {
                        data.push(0);
                    } else {
                        data.push(Math.round(value.percRight));
                    }
                } else if (side == 2) {
                    if (isNaN(value.percLeft)) {
                        data.push(0);
                    } else {
                        data.push(Math.round(value.percLeft));
                    }
                }
            }
        }

        if (type == "leg") {
            let newData1 = data.slice(0,2);
            let newData2 = data.slice(2,4);
            let remainingData = data.slice(4);

            let newData1Max = Math.max(...newData1);
            let newData2Max = Math.max(...newData2);

            remainingData.unshift(newData2Max);
            remainingData.unshift(newData1Max);

            data = remainingData;
        }

        return data;
    };

    const muscle_names = groupNames(bodypart, calculatedValues);

    const chart_data_right = chartData(1, bodypart, calculatedValues);
    const chart_data_left = chartData(2, bodypart, calculatedValues)

    const label_right = $_('calculator.results.right');
    const label_left = $_('calculator.results.left');

    function createChart(chartId, labels, data_right, data_left, l_right, l_left) {
        var ctx = document.getElementById(chartId).getContext('2d');

        ctx.height = 500;

        // Colors in the ResultChart (except bar colors) have been replaced by a higher contrast variant.
        // To see old color codes, go to global.css

        var resultChart = new Chart(ctx, {
            type: 'bar',
            plugins: [ChartDataLabels],
            data: {
                labels: labels,
                datasets: [
                    {
                        label: l_right,
                        data: data_right,
                        backgroundColor: '#40B69E',   
                    },
                    {
                        label: l_left,
                        data: data_left,
                        backgroundColor: '#C36568',    
                    }
            ]
            },
            options: {
                plugins: {
                    datalabels: {
                        color: '#205F6F',
                        anchor: 'end',
                        align: 'top',
                        offset: 1,
                    }
                },
                legend: {
                    display: false
                },
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                        gridLines: { 
                            color: '#FFFFFF', 
                            zeroLineWidth: 2,
                            zeroLineColor: '#205F6F'
                        },
                        ticks: {
                            fontColor: '#205F6F',
                            fontFamily: "Ubuntu",
                        },
                    }],
                    yAxes: [{
                        position: 'top',
                        ticks: { 
                            beginAtZero: true,
                            fontColor: '#205F6F',
                            fontFamily: "Ubuntu",
                            padding: 10,
                            stepSize: 25,
                            suggestedMax: 125,
                        },
                        gridLines: { 
                            color: 'rgba(43,133,156, 0.3)',
                            drawTicks: false,
                            zeroLineWidth: 2,
                            zeroLineColor: '#205F6F',
                            tickMarkLength: false,
                        }
                    }]
                }
            }
        })
    }

    onMount(async () => {
        createChart(chartId, muscle_names, chart_data_right, chart_data_left, label_right, label_left);
    });

</script>

<style>

    span {
        font-size: var(--typeSizeSmall);
        display: block;
    }

    .graph_legend {
        display: flex;
        margin: var(--spacingSmall) 0 var(--spacingLarge);
        align-items: center;
    }

    .legend_box {
        width: 15px;
        height: 15px;
        border-radius: 4px;
    }

    .legend_green {
        background-color: #40B69E;
    }

    .legend_red {
        background-color: #C36568;
    }

    .graph_legend span {
        margin: 0 var(--spacingLarge) 0 var(--spacingSmall);
    }

    canvas {
        margin-bottom: var(--spacingXXLarge);
        max-height: 260px;
        width: 100%;
        min-width: 600px;
        max-width: 1200px;
    }

    .short-chart {
        /* used for bodypart arm */
        max-width: 700px;
    }

    @media print {
        canvas {
            min-height: 100%;
            max-width: 100%;
            max-height: 100%;
            height: auto!important;
            width: auto!important;
        }
        canvas.short-chart {
            max-width: 70%;
        }
    }

</style>

<span>{$_('calculator.results.graph_header')}</span>
<div class="graph_legend">
    <div class="legend_box legend_green"></div><span>{$_('calculator.results.right')}</span>
    <div class="legend_box legend_red"></div><span>{$_('calculator.results.left')}</span>
</div>

<canvas class="{bodypart === 'arm' ? 'short-chart' : ''}" id="resultChart-{bodypart}" width="400" height="400"></canvas>
